import breadcrumbs from './breadcrumbs'
import head from './head'
import videoTour from './videoTour'

export default {
  breadcrumbs,
  head,
  videoTour,
}
